export default __webpack_public_path__ + "static/media/userHeroImage.eef7fb70.png";